<template>
  <v-card flat tile>
    <v-card-title>Past Investments / Auction Results</v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="investments"
        class="mb-12 elevation-1"
        no-data-text="You have no past investments."
      >
        <template v-slot:item.mainImage="{ item }">
          <v-img
            max-width="100px"
            class="my-1"
            :src="parseImage(item.images)"
          ></v-img>
        </template>

        <template v-slot:item.title="{ item }">
          <router-link :to="`/flip/${item.id}`">
            {{ item.title }}
          </router-link>
        </template>

        <template v-slot:item.sharesForSale="{ item }">
          {{ calcFunded(item.sharesForSale, item.totalShares) }}%
        </template>

        <template v-slot:item.metadata.projectedRoi="{ item }">
          {{ item.metadata.projectedRoi }}% ROI
        </template>

        <template v-slot:item.actualRoi="{ item }">
          {{ item.actualRoi }}% ROI
        </template>

      </v-data-table>
    </v-card-text>

  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PastInvestments',

    components: {
    },

    props: {
      userId: Number
    },

    computed: {
      ...mapGetters([
        'pastInvestments',
        'adminUserViewPastInvestments'
      ])
    },

    data: () => ({
      investments: [],

      headers: [
        {
          text: '',
          value: 'mainImage'
        },
        {
          text: 'Asset',
          value: 'title'
        },
        {
          text: 'Total Shares',
          value: 'totalShares'
        },
        {
          text: 'Share Price',
          value: 'pricePerShare'
        },
        {
          text: 'Shares Owned',
          value: 'sharesOwned'
        },
        {
          text: '% funded',
          value: 'sharesForSale'
        },
        {
          text: 'Projected ROI',
          value: 'metadata.projectedRoi'
        },
        {
          text: 'Realized Shared ROI',
          value: 'actualRoi'
        }
      ]
    }),

    methods: {
      ...mapActions([
        'getPastInvestments',
        'adminGetPastInvestments'
      ]),

      calcFunded: function(avail, tot) {
        let fundedPerc = ((tot - avail) / tot) * 100

        return Math.round(fundedPerc)
      },

      // Parse out the small main image.
      parseImage: function(images) {
        if (images.length > 0) {
          return images.find(i => i.type === 'mainImage').smallUri
        }
        return ''
      }
    },

    async created() {
      // Admin viewing a user.
      if (this.userId) {
        await this.adminGetPastInvestments(this.userId).then(() => {
          this.investments = this.adminUserViewPastInvestments
        })
      }
      // User viewing their account.
      else {
        await this.getPastInvestments().then(() => {
          this.investments = this.pastInvestments
        })
      }
    }
  }
</script>
